import { purchaseMotionsGetRpc } from 'growth-monetization-service-types';
import httpClient from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { createRpcClientV2 } from 'rpc-client-utils';
import { SALES_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { MERCH_CARD } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
// errors thrown by hub-http add extra information to the error in hub-http#buildResponse
const isHubHttpError = error => Number.isInteger(error === null || error === void 0 ? void 0 : error.status);

// errors thrown by client-types operations add the original hub-http error to the `error.cause` in createHttpRpcClientV2
const isRpcError = error => !!error.cause && isHubHttpError(error.cause);
export const getPurchaseMotions = ({
  location = [MERCH_CARD],
  apiName = [SALES_HUB_PROFESSIONAL]
}) => createRpcClientV2({
  hubHttpClient: httpClient
}).call(purchaseMotionsGetRpc, {
  queryParameters: {
    location,
    apiName
  }
}).catch(error => {
  if (!isRpcError(error) || error.cause.status !== 0) {
    Raven.captureException(error);
  }
  throw error;
});